import { db } from '@/backend/firebase/firebase';
import { createFirestoreRefs, createConverter } from '@/shared/lib/firestore-refs-factory';

// Initialize the refs with this package's specific DB instance
const refs = createFirestoreRefs(db);

// Export exactly what the package expects
export const {
  fieldToFilter,
  tasaDoc,
  publicRef,
  marketingConfigRef,
  slugRef,
  slugsCol,
  ownerRef,
  ownersCol,
  appointmentRef,
  appointmentsCol,
  saleRef,
  salesCol,
  clientsCol,
  clientDoc,
  servicesCol,
  serviceDoc,
  transactionsCol,
  transactionRef,
  balancesCol,
  balanceDoc,
  adminSettingsRef,
  adminPrivateRef,
  adminBillingCol,
  globalPaymentMethodsDoc,
  legalVersionsCol,
  userLegalAcceptancesCol,
  settlementsCol,
  settlementRef,
  expensesCol,
  productsCol,
  productRef,
  marketingThreadsCol,
  marketingThreadRef,
  marketingThreadMessagesCol,
  coursesCol,
  courseRef,
  enrollmentsCol,
  enrollmentRef,
  // --- NATIVE MARKETING ---
  marketingCampaignsCol,
  marketingCampaignRef,
  marketingAdSetsCol,
  marketingAdSetRef,
  marketingAdsCol,
  marketingAdRef,
} = refs;


// Re-export the converter just in case it's used directly anywhere
export const converter = createConverter;
